"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_1 = __importDefault(require("@seaweb/coral/hoc/styled"));
var useForkRef_1 = __importDefault(require("@seaweb/coral/hooks/useForkRef"));
var LayoutContext_1 = require("./LayoutContext");
var Region = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n\n  &:focus {\n    outline: none;\n  }\n"], ["\n  position: relative;\n\n  &:focus {\n    outline: none;\n  }\n"])));
var SkippableRegion = react_1.forwardRef(function (_a, ref) {
    var _as = _a._as, _b = _a.tabIndex, tabIndex = _b === void 0 ? -1 : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, name = _a.name, label = _a.label, props = __rest(_a, ["_as", "tabIndex", "disabled", "name", "label"]);
    var _d = LayoutContext_1.useRootLayoutContext() || {}, registerSkipNav = _d.registerSkipNav, unregisterSkipNav = _d.unregisterSkipNav;
    var ownRef = react_1.useRef(null);
    react_1.useEffect(function () {
        if (!disabled && registerSkipNav) {
            registerSkipNav(name, { label: label, el: ownRef.current });
            return function () { return unregisterSkipNav(name); };
        }
        return undefined;
    }, [disabled, label, name, registerSkipNav, unregisterSkipNav]);
    return react_1.default.createElement(Region, __assign({ as: _as, ref: useForkRef_1.default(ref, ownRef), tabIndex: tabIndex }, props));
});
exports.default = SkippableRegion;
var templateObject_1;
